module.exports = __webpack_public_path__ + "img/chevron-down.c66b213d.svg";